import { Controller } from "@hotwired/stimulus";

// HMIS DE 3.15 role select: shows the free-text detail label for
// "other relative" / "unrelated" and warns when picking "self" would replace
// the current head of household.
export default class extends Controller {
  static targets = ["roleSelect", "detailWrap", "headWarning"];

  declare readonly roleSelectTarget: HTMLSelectElement;
  declare readonly detailWrapTarget: HTMLElement;
  declare readonly headWarningTarget: HTMLElement;
  declare readonly hasHeadWarningTarget: boolean;

  connect() {
    this.sync();
  }

  sync() {
    const role = this.roleSelectTarget.value;
    const detailable = role === "other_relative" || role === "unrelated";
    this.detailWrapTarget.classList.toggle("hidden", !detailable);
    if (this.hasHeadWarningTarget) {
      this.headWarningTarget.classList.toggle("hidden", role !== "self");
    }
  }
}
